export enum WarningIcons {
  ERROR = 'error',
  STOP = 'report',
  WARN = 'warning',
  ANNOUNCE = 'announcement',
}
